<template>
  <div>
    <b-button variant="outline-primary" size="sm"  @click="fetchForms()" class="mr-1">
      {{$t('fetchForms')}}
    </b-button><br>
    Total Forms:{{totalRows}}<br>
    <br>
    <ul>
      <li v-bind:key="form.id" v-for="form in forms">{{form.id}}</li>
    </ul>
    <b-button variant="outline-primary" size="sm"  @click="migrateForms()" class="mr-1">
      {{$t('Run Migration')}}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'MigrationTemp',
  data () {
    return {
      wtf: '',
      forms: [],
      totalRows: 0
    }
  },
  mounted () {
    console.log('dssddsssdds')
  },
  methods: {
    migrateForms () {
      this.forms.forEach(async function (formData) {
        var res = formData.ref.set({
          priority: 100
        }, { merge: true })
        console.log('results', res)
      })
    },
    fetchForms () {
      let self = this
      this.$firebase.firestore().collectionGroup('forms').get().then(function (querySnapshot) {
        self.forms = []
        querySnapshot.forEach(async function (doc) {
          console.log(doc)
          var formData = doc.data()
          formData.ref = doc.ref
          formData.id = doc.id

          self.forms.push(formData)
        })
        // Set the initial number of items
        self.totalRows = self.forms.length
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MigrationTemp.vue